import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';

import theme from './theme';
import avatarBkg from '../images/header-avatar.svg';
import headerBkg from '../images/header-bkg.svg';
import mePhoto from '../images/me.jpg';

/**
 * Emotion style classes
 */
const avatarSize = '300px';

const headerBlock = css`
  background-color: ${theme.color.primary};
  background-image: url(${headerBkg}),
    linear-gradient(
      to right bottom,
      ${theme.color.primary},
      ${theme.color.primaryBlack}
    );
  background-position: top right, top left;
  background-repeat: no-repeat;
  background-size: cover;
  border-bottom: 1em solid ${theme.color.highlight};
  box-shadow: 0 3px 12px ${theme.color.shadow};
  margin-bottom: 3em;

  h1 {
    border-bottom: 1px solid ${theme.color.highlight};
  }

  .is-hidden-mobile {
    h1,
    h2 {
      color: white;
    }

    h2 {
      margin-left: 3em;
    }

    width: 50%;
  }

  .is-hidden-tablet {
    h1,
    h2 {
      color: white;
    }

    h1 {
      text-shadow: 2px 2px 2px ${theme.color.primaryDark};
    }

    h2 {
      text-shadow: 1px 1px 1px ${theme.color.primaryDark};
    }
  }

  figure.image {
    margin: 1em auto;
    max-height: ${avatarSize};
    max-width: ${avatarSize};
  }
`;

const avatar = css`
  background-image: url(${avatarBkg});
  background-position: bottom center;
  background-repeat: no-repeat;
  background-size: ${avatarSize};
`;

const imageBorder = css`
  border: 0.5em solid white;
  box-shadow: 0 12px 12px ${theme.color.shadow};
`;

/**
 * Components
 */
const Header = ({ fullName, jobTitle }) => (
  <header className={`hero ${headerBlock}`}>
    <div className={`hero-body ${avatar}`}>
      <div className="container">
        <div className="is-hidden-mobile">
          <h1 className={`title is-1 has-text-weight-light ${theme.triangle}`}>
            {fullName}
          </h1>
          <h2 className="subtitle has-text-weight-light">{jobTitle}</h2>
        </div>
        <div className="is-hidden-tablet has-text-centered">
          <h1 className="title is-1">{fullName}</h1>
          <h2 className="subtitle has-text-weight-light">{jobTitle}</h2>
        </div>
        <figure className="image">
          <img
            alt={fullName}
            className={`is-rounded ${imageBorder}`}
            src={mePhoto}
            title={fullName}
          />
        </figure>
      </div>
    </div>
  </header>
);

Header.propTypes = {
  fullName: PropTypes.string,
  jobTitle: PropTypes.string,
};

export default Header;
